import { defineNuxtRouteMiddleware, setPageLayout } from '#app'
import { getAppContext } from '@b2ag/micro-front-tools'

export default defineNuxtRouteMiddleware((to) => {
  const layout = to.meta?.layout || getAppContext().appFrontType
  // @ts-expect-error layout value is dynamic but always matches a valid layout key at runtime
  setPageLayout(layout)
  // eslint-disable-next-line no-param-reassign
  to.meta = {
    ...(to.meta || {}),
    layout: layout as any,
  }
})
